'use client';

import { useModernLayoutContext } from '@/features/HomepageHero/components/Context';
import { modernVariantCarouselDurationSec } from '@/features/HomepageHero/constants/carousel';
import { useEffect, useRef, useState } from 'react';

/**
 * Hook to handle carousel and logic for the modern variant of the homepage hero
 */
export const useSlideTimer = () => {
  const {
    handleSelectSlide: setSelectedSlideIndex,
    slides,
    activeSlideIndex,
  } = useModernLayoutContext();
  const durationSec = modernVariantCarouselDurationSec;

  const nbItems = slides.length;
  const [timerKey, setTimerKey] = useState(0);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleSelectSlide = (index: number) => {
    const isSameIndex = index === activeSlideIndex;

    setSelectedSlideIndex(index);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (isSameIndex) {
      timeoutRef.current = setTimeout(() => {
        const nextIndex = (index + 1) % nbItems;
        setSelectedSlideIndex(nextIndex);
      }, durationSec * 1000);
    }
  };

  useEffect(() => {
    if (nbItems === 0) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const nextIndex = (activeSlideIndex + 1) % nbItems;
    timeoutRef.current = setTimeout(() => {
      setSelectedSlideIndex(nextIndex);
    }, durationSec * 1000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [activeSlideIndex, nbItems, durationSec, setSelectedSlideIndex]);

  return {
    timerKey,
    handleSelectSlide,
    setTimerKey,
  };
};
